/* Lorenge product page on Arcastral (Gustav build, job 20261023-0909).
   Bundle bars (one-time variants), add to cart with the bundle's free gifts, the source UpCart-style drawer
   (reservation timer, savings, checkout), header cart count and the language list of this funnel. */
(function () {
  var GB = window.GB || {};
  var root = GB.root || '/';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- money in the visitor's currency (format taken from a Liquid sample) ---------- */
  var sample = GB.money_sample || '$1,234.56';
  var m = sample.match(/^(.*?)1([.,'\s]?)234([.,])56(.*)$/);
  function money(cents) {
    cents = Math.round(cents || 0);
    if (!m) return (cents / 100).toFixed(2);
    var neg = cents < 0; cents = Math.abs(cents);
    var whole = Math.floor(cents / 100).toString(), dec = ('0' + (cents % 100)).slice(-2);
    whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, m[2]);
    return (neg ? '-' : '') + m[1] + whole + m[3] + dec + m[4];
  }

  /* ---------- bundle bars ---------- */
  var form = $('#gb-main-form');
  function selected() {
    var b = $('[data-gb-bundles] .kaching-bundles__bar--selected');
    return b ? parseInt(b.getAttribute('data-gb-index'), 10) : (GB.preselect || 0);
  }
  function select(bar) {
    $$('[data-gb-bundles] .kaching-bundles__bars > .kaching-bundles__bar').forEach(function (x) {
      x.classList.toggle('kaching-bundles__bar--selected', x === bar);
      var i = x.querySelector('input[type=radio]'); if (i) i.checked = x === bar;
    });
    var vid = bar.getAttribute('data-gb-variant');
    if (form) { var id = form.querySelector('input[name=id]'); if (id) id.value = vid; }
    var price = bar.querySelector('.kaching-bundles__bar-price');
    $$('[data-gb-sticky-price]').forEach(function (s) { if (price) s.textContent = price.textContent.trim(); });
  }
  $$('[data-gb-bundles] .kaching-bundles__bars > .kaching-bundles__bar').forEach(function (bar) {
    bar.addEventListener('click', function (e) {
      if (e.target.closest('a')) e.preventDefault();
      select(bar);
    });
  });

  /* ---------- cart ---------- */
  function post(path, body) {
    return fetch(root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body), credentials: 'same-origin' })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function getCart() { return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  var bundleById = {}; (GB.variants || []).forEach(function (v, n) { bundleById[v.id] = { n: n, gifts: v.gifts }; });
  var giftIds = GB.gift_ids || {}; var giftKeyById = {}; Object.keys(giftIds).forEach(function (k) { giftKeyById[giftIds[k]] = k; });
  var TAGS = { en: ['', '2+1 FREE', '3+2 FREE'], es: ['', '2+1 GRATIS', '3+2 GRATIS'], it: ['', '2+1 GRATIS', '3+2 GRATIS'], de: ['', '2+1 GRATIS', '3+2 GRATIS'] }[GB.lang] || ['', '', ''];

  function addSelected() {
    var n = selected(); var v = GB.variants[n];
    var items = [{ id: v.id, quantity: 1 }];
    (v.gifts || []).forEach(function (g) { items.push({ id: giftIds[g.key], quantity: g.qty, properties: { _gift: v.title } }); });
    return post('cart/add.js', { items: items });
  }
  function desiredGifts(cart) {
    var want = {};
    Object.keys(giftIds).forEach(function (k) { want[k] = 0; });
    cart.items.forEach(function (it) {
      var b = bundleById[it.variant_id]; if (!b) return;
      (b.gifts || []).forEach(function (g) { want[g.key] += g.qty * it.quantity; });
    });
    return want;
  }
  function reconcile(cart) {
    // gifts follow the bundles in the cart: never more (or fewer) free items than the bundles include
    var want = desiredGifts(cart), ops = [];
    Object.keys(giftIds).forEach(function (k) {
      var lines = cart.items.filter(function (it) { return it.variant_id === giftIds[k]; });
      var have = lines.reduce(function (a, it) { return a + it.quantity; }, 0);
      if (have === want[k]) return;
      if (!lines.length) { ops.push(function () { return post('cart/add.js', { items: [{ id: giftIds[k], quantity: want[k], properties: { _gift: 'bundle' } }] }); }); return; }
      ops.push(function () { return post('cart/change.js', { id: lines[0].key, quantity: want[k] }); });
      lines.slice(1).forEach(function (l) { ops.push(function () { return post('cart/change.js', { id: l.key, quantity: 0 }); }); });
    });
    if (!ops.length) return Promise.resolve(cart);
    return ops.reduce(function (p, f) { return p.then(f); }, Promise.resolve()).then(getCart);
  }

  /* ---------- drawer ---------- */
  var drawer = $('[data-gb-drawer]'); var panel = drawer && drawer.querySelector('[data-gb-panel]');
  var backdrop = drawer && drawer.querySelector('#UpcartPopupBackDrop');
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('upcartPopupShow'); drawer.setAttribute('aria-hidden', 'false');
    panel && panel.classList.add('styles_active__'); backdrop && backdrop.classList.add('styles_active__');
    document.documentElement.classList.add('gb-cart-open'); startTimer();
  }
  function closeDrawer() {
    if (!drawer) return;
    panel && panel.classList.remove('styles_active__'); backdrop && backdrop.classList.remove('styles_active__');
    drawer.setAttribute('aria-hidden', 'true'); document.documentElement.classList.remove('gb-cart-open');
    setTimeout(function () { drawer.classList.remove('upcartPopupShow'); }, 250);
  }
  var timerH;
  function startTimer() {
    var el = drawer.querySelector('[data-gb-timer]'); if (!el) return;
    var key = 'gb-lq-reserve', start;
    try { start = parseInt(sessionStorage.getItem(key), 10); if (!start) { start = Date.now(); sessionStorage.setItem(key, String(start)); } } catch (e) { start = start || Date.now(); }
    clearInterval(timerH);
    var tick = function () {
      var left = Math.max(0, 600 - Math.floor((Date.now() - start) / 1000));
      if (left === 0) { try { sessionStorage.setItem(key, String(Date.now())); start = Date.now(); left = 600; } catch (e) {} }
      el.textContent = ('0' + Math.floor(left / 60)).slice(-2) + ':' + ('0' + (left % 60)).slice(-2);
    };
    tick(); timerH = setInterval(tick, 1000);
  }
  function setCount(n) {
    $$('[data-gb-count]').forEach(function (c) { c.textContent = n; c.classList.toggle('opacity-0', !n); });
  }
  function bundleTagOf(it, cart) {
    var b = bundleById[it.variant_id]; if (b) return TAGS[b.n];
    if (giftKeyById[it.variant_id]) {
      var main = cart.items.filter(function (x) { return bundleById[x.variant_id] && bundleById[x.variant_id].n > 0; })[0];
      return main ? TAGS[bundleById[main.variant_id].n] : '';
    }
    return '';
  }
  function render(cart) {
    if (!drawer) return;
    var list = drawer.querySelector('[data-gb-cart-items]'); var empty = drawer.querySelector('[data-gb-cart-empty]');
    var tpl = document.createElement('div'); list.innerHTML = '';
    var savings = 0, tag = '';
    var items = cart.items.slice().sort(function (a, b) { return (giftKeyById[a.variant_id] ? 1 : 0) - (giftKeyById[b.variant_id] ? 1 : 0); });   // bundle first, its gifts below (source order)
    items.forEach(function (it) {
      tpl.innerHTML = GB.item_tpl; var row = tpl.firstElementChild;
      row.id = it.key; row.setAttribute('data-gb-key', it.key);
      var url = it.url && it.url.indexOf('/products/' + GB.handle) !== -1 ? GB.product_url : (giftKeyById[it.variant_id] ? GB.product_url : it.url);
      row.querySelectorAll('a').forEach(function (a) { a.setAttribute('href', url); a.setAttribute('aria-label', it.product_title); });
      var img = row.querySelector('img'); if (img) { img.src = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'height=176' : ''; img.alt = it.product_title; }
      var tl = row.querySelector('.upcart-product-title-link');
      if (tl) tl.textContent = it.product_title;
      var props = row.querySelector('.upcart-item-properties');
      if (props) { props.innerHTML = ''; if (!it.product_has_only_default_variant && it.variant_title) { var p = document.createElement('p'); p.className = 'upcart-item-property'; p.textContent = it.variant_title; props.appendChild(p); } }
      var cmpUnit = (GB.compare || {})[it.variant_id] || 0;
      var cmp = cmpUnit * it.quantity, price = it.final_line_price;
      var ce = row.querySelector('.upcart-item-compare-price'), pe = row.querySelector('.upcart-item-price'), se = row.querySelector('.upcart-product-savings');
      if (pe) pe.textContent = money(price);
      if (ce) { ce.textContent = cmp > price ? money(cmp) : ''; ce.parentNode.style.display = cmp > price ? '' : 'none'; }
      if (se) { se.textContent = cmp > price ? '(' + GB.t['Risparmia'] + ' ' + money(cmp - price) + ')' : ''; se.parentNode.style.display = cmp > price ? '' : 'none'; }
      if (cmp > price) savings += cmp - price;
      var t = bundleTagOf(it, cart); if (t && !tag) tag = t;
      var badge = row.querySelector('.upcart-discount-code-badge');
      if (badge) { if (t) badge.querySelector('.upcart-discount-code-text').textContent = t; else badge.style.display = 'none'; }
      var q = row.querySelector('.upcart-product-quantity-input'); if (q) q.value = it.quantity;
      var isGift = !!giftKeyById[it.variant_id];
      row.querySelectorAll('.upcart-product-quantity-minus,.upcart-product-quantity-plus').forEach(function (b) {
        if (isGift) { b.disabled = true; b.style.opacity = '.5'; }
        b.addEventListener('click', function () { change(it.key, it.quantity + (b.classList.contains('upcart-product-quantity-plus') ? 1 : -1)); });
      });
      if (q) { if (isGift) q.readOnly = true; q.addEventListener('change', function () { change(it.key, Math.max(0, parseInt(q.value, 10) || 0)); }); }
      var rm = row.querySelector('[data-gb-remove]');
      if (rm) { if (isGift) rm.style.visibility = 'hidden'; rm.addEventListener('click', function () { change(it.key, 0); }); }
      list.appendChild(row);
    });
    var n = cart.item_count;
    var h = drawer.querySelector('[data-gb-cart-heading]'); if (h) { h.textContent = GB.t['Carrello'] + ' • ' + n; h.setAttribute('aria-label', h.textContent); }
    if (empty) empty.hidden = !!n;
    var foot = drawer.querySelector('.upcart-footer'); if (foot) foot.style.display = n ? '' : 'none';
    var ann = drawer.querySelector('.upcart-announcement'); if (ann) ann.parentNode.style.display = n ? '' : 'none';
    var sr = drawer.querySelector('[data-gb-savings-row]');
    if (sr) {
      sr.style.display = savings > 0 ? '' : 'none';
      var amt = sr.querySelector('[data-gb-cart-savings]'); if (amt) amt.textContent = '- ' + money(savings);
      var tg = sr.querySelector('.upcart-discount-code-badge'); if (tg) { tg.style.display = tag ? '' : 'none'; tg.querySelector('[data-gb-savings-tag]').textContent = tag; }
    }
    var co = drawer.querySelector('[data-gb-checkout]'); if (co) co.textContent = GB.t['Vai al pagamento'] + ' • ' + money(cart.total_price);
    setCount(n);
  }
  var busy = false;
  function refresh() { return getCart().then(reconcile).then(function (c) { render(c); return c; }); }
  function change(key, qty) {
    if (busy) return; busy = true;
    post('cart/change.js', { id: key, quantity: qty }).then(reconcile).then(render).catch(function () {}).then(function () { busy = false; });
  }
  function onAdd(e) {
    if (e) { e.preventDefault(); e.stopImmediatePropagation(); }
    if (busy) return; busy = true;
    var btns = $$('[data-gb-atc]'); btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
    addSelected().then(getCart).then(reconcile).then(function (c) { render(c); openDrawer(); })
      .catch(function (err) { console.warn('add to cart', err && (err.description || err.message)); })
      .then(function () { busy = false; btns.forEach(function (b) { b.removeAttribute('aria-busy'); }); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-gb-atc]'); if (b) { onAdd(e); return; }
    var o = e.target.closest && e.target.closest('[data-gb-cart-open]'); if (o) { e.preventDefault(); e.stopImmediatePropagation(); refresh().then(openDrawer); return; }
    var c = e.target.closest && e.target.closest('[data-gb-cart-close]'); if (c) { if (c.tagName !== 'A') e.preventDefault(); closeDrawer(); return; }
    var l = e.target.closest && e.target.closest('[data-gb-lang-url]'); if (l) { e.preventDefault(); location.href = l.getAttribute('data-gb-lang-url'); }
  }, true);
  if (form) form.addEventListener('submit', onAdd, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && drawer.getAttribute('aria-hidden') === 'false') closeDrawer(); });
  refresh().catch(function () {});
})();
